import React from 'react';
import PropTypes from 'prop-types';

import CheckSVG from './react-icon-check';

import './index.scss';

export const uniqueID = (n = 10000) => Math.floor(Math.random() * n);

const RoyalCheckbox = ({id, onClick = null, checked, color = '#260354', className = '', ariaLabel}) => {
  if (!id) {
    throw new Error(
      'Inputs need ids that  are the same for attribute as their labels https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox'
    );
  }

  return (
    <div className={`RoyalCheckbox ${className} `} onClick={onClick}>
      <input className="RoyalCheckbox__input" id={id} type="checkbox" checked={checked} readOnly />
      <label
        htmlFor={id}
        className={`RoyalCheckbox__label ${checked ? 'RoyalCheckbox__label--darkenBorder' : ''}`}
        aria-label={ariaLabel}
      >
        {checked && <CheckSVG color={color} />}
      </label>
    </div>
  );
};

RoyalCheckbox.propTypes = {
  /**
   * If checkbox is checked
   */
  checked: PropTypes.bool.isRequired,

  /**
   * Checkbox Id
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /**
   * OnClick callback method
   */
  onClick: PropTypes.func,

  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default RoyalCheckbox;
